'use client';
import * as Sentry from '@sentry/nextjs';
import NextError from 'next/error';
import { FC, useEffect } from 'react';

type Props = {
  error: Error & {
    digest?: string;
  };
};

const GlobalError: FC<Props> = ({ error }) => {
  useEffect(() => {
    Sentry.setTag('total-crash', true);
    Sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body>
        <NextError statusCode={0} />
      </body>
    </html>
  );
};

export default GlobalError;
